<template>
    <div>
        <el-card>
            <nav class="input" style="width: auto">
                <el-input
                    v-model="search.keyword"
                    size="medium"
                    placeholder="关键词搜索"
                    clearable
                    @keyup.enter.native="subimt"
                />
            </nav>
            <nav class="input" style="width: 150px">
                <el-button size="small" @click="reset">重置</el-button>
                <el-button type="primary" size="small" @click="subimt">搜索</el-button>
            </nav>
        </el-card>

        <el-card style="margin-top: 10px">
            <el-table
                :data="list"
                style="width: 100%"
                border
                stripe
                :header-cell-style="rowClass"
            >
                <el-table-column label="ID" prop="id" width="80" />
                <el-table-column label="用户ID" prop="userId" width="110" />
                <el-table-column label="用户名" prop="userName" min-width="100" />
                <el-table-column label="企业" min-width="200" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        {{ row.enterpriseName || '-' }}（id:{{ row.enterpriseId }}）
                    </template>
                </el-table-column>
                <el-table-column label="反馈内容" prop="content" min-width="200" show-overflow-tooltip />
                <el-table-column label="提交时间" prop="createTime" width="160" />
            </el-table>

            <el-pagination
                :current-page="search.page"
                background
                :page-sizes="[3, 5, 10, 15]"
                :page-size="search.pageSize"
                layout="total, prev, pager, next"
                :total="total"
                @current-change="handleCurrentChange"
            />
        </el-card>
    </div>
</template>

<script>
import list from '/src/mixin/list.js'

export default {
    mixins: [list],
    data() {
        return {
            search: {
                keyword: '',
                page: 1,
                pageSize: 10,
            },
        }
    },
    created() {
        this.getlist()
    },
    methods: {
        handleCurrentChange(e) {
            this.search.page = e
            this.getlist()
        },
        async getlist() {
            const { data: res } = await this.$http.get('/admin/Feedback/getList', {
                params: {
                    ...this.search,
                },
            })
            if (res.errorCode == 200) {
                this.list = res.data.list || []
                this.total = res.data.totalCount || 0
            }
        },
        subimt() {
            this.search.page = 1
            this.getlist()
        },
    },
}
</script>

<style lang="less" scoped></style>
